import React from "react";
import { Row, Col, Card } from "react-bootstrap";
import { FaCertificate } from "react-icons/fa";

function Certifications() {
  const certifications = [
    {
      title: "Successfully earned a certificate on Internet of Things",
      institution: "NPTEL",
      description: "Completed a comprehensive course on IoT, including assignments.",
    },
    {
      title: "Successfully completed ReactJS certification",
      institution: "Upgrad",
      description: "Earned certification for completing a ReactJS course focused on building dynamic web applications.",
    },
    {
      title: "Published Review Paper on Web Mining for Suspicious Keywords",
      institution: "OSIET Chennai",
      description: "Published a Review Paper on Web Mining for Suspicious Keywords at the 12th(OSIET) International Conference.",
    },
  ];

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
      <h1 className="project-heading" style={{ paddingBottom: "20px" }}>
        My <strong className="purple">Certifications and Publications</strong>
      </h1>
      {certifications.map((cert, index) => (
        <Col md={4} key={index} className="certification-card">
          <Card style={{ width: "18rem", marginBottom: "20px", color: 'Black' }}>
            <Card.Body>
              <Card.Title>
                <FaCertificate className="purple" /> {cert.title}
              </Card.Title>
              <Card.Subtitle style={{color:'purple'}} className="">{cert.institution}</Card.Subtitle>
              <Card.Text>{cert.description}</Card.Text>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
}

export default Certifications;
